export default __webpack_public_path__ + "static/media/DSC05979.7f782d3e.jpg";